"use client";

import { Suspense, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import Analytics from "@/common/Analytics";
import Layout from "@/components/Layout/Layout";
import ThemeProviders from "@/theme/ThemeProviders";
import { proccesVar, userVar } from "@/store";
import { handleRefcodeCheck } from "@/api";
import { trackCustomEvent } from "@/common/gtm";
import { HI_MAMI_CLICK_ID_PARAM, setHiMamiClickIdCookie } from "@/common/himami";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const searchParams = useSearchParams();

  useEffect(() => {
  //  console.log(userVar(), proccesVar());
    const clickId = searchParams?.get("click_id");//(HI_MAMI_CLICK_ID_PARAM);
    if (clickId) {
      setHiMamiClickIdCookie(clickId);
    }

    const refcode = searchParams?.get("refcode");
    const refid = searchParams?.get("refid");

    if (refid && userVar().refId !== refid) {
      userVar({ ...userVar(), refId: refid });
      proccesVar({ ...proccesVar(), refId: refid });
    }

    if (!refcode) return;

    // ✅ Prevent unnecessary re-check if already captured
    if (userVar().referralCode === refcode) return;

    handleRefcodeCheck(refcode)
      .then((referral) => {
        console.log(referral);
        if (!referral) {
          console.log("Invalid refcode");
          return;
        }

        userVar({
          ...userVar(),

          referralCode: referral.referralCode,
          referralTitle: referral.title ?? "",
          referralSubTitle: referral.subtitle ?? "",
          referralCampaignName: referral.campaign ?? "",
          referralSpecialTerms:referral.specialTerms ?? "",
          selectedPlanNameString: referral.title ?? "",
          // optional – keep backward compatibility if still used in flows
          ////packageChosen: referral.referralCode,
        });
        console.log("[gtm debug] personal_details_step1_screen", {
          selectedPlanNameString: referral.title ?? "",
        });
        trackCustomEvent(
          "personal_details_step1_screen",
          referral.title ?? ""
        );
       // console.log("Referral captured:", referral);
      })
      .catch((error) => {
        console.error("Error handling refcode:", error);
      });
  }, [searchParams]);

  return (
    <>
      <Suspense>
        <Analytics />
      </Suspense>

      <ThemeProviders>
        <Layout>{children}</Layout>
      </ThemeProviders>
    </>
  );
}
